module.exports = __webpack_public_path__ + "static/media/docs.04c7379a.svg";